import type { CurrencyListResponse } from './api';

export const normalizeCurrencyList = (list: CurrencyListResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.currencyName,
    value: row.code,
  }));
};
